import { Component, OnInit } from '@angular/core';
import { SelectDepartamentosService } from "../../services/select-departamentos.service";

@Component({
  selector: 'core-select-departamentos',
  templateUrl: './select-departamentos.component.html',
})
export class SelectDepartamentosComponent implements OnInit {
  departamento: any[]; 
  departamentoSelected: any; 

  constructor(private SelectDepartamentosService: SelectDepartamentosService) { }

  ngOnInit() {
    this.getDepartamentos(); 
  }

  getDepartamentos() {
    this.SelectDepartamentosService.getDepartamentosControlBox().subscribe(
      data => {
        this.departamento = data; 
      },
      error => {
        console.error('Error al obtener los departamentos', error);
      }
    );
  }

  changeLang(selectedValue: any) {
    this.departamentoSelected = selectedValue; 
  }

}



// WEBPACK FOOTER //
// ./src/app/control-core/shared/select-departamentos/select-departamentos.component.ts